import type { ReadManyQuery } from '#layers/collection-query/public';
import type { ResolvedMonospaceCollection } from '#layers/data-model/public';
import { createBlockRootContextProperty } from '#layers/block-engine/public';

export interface ListingQueryBlockRootContext {
	/**
	 * Collection used by the published listing query.
	 */
	collection?: ResolvedMonospaceCollection;
	/**
	 * Read-many query produced by the active listing layout.
	 */
	query?: ReadManyQuery;
}

const listingQueryBlockRootContext = createBlockRootContextProperty<ListingQueryBlockRootContext>('listingQuery');

/**
 * Publishes listing query details from a rendered listing layout.
 */
export const exposeListingQueryToBlockRootContext = listingQueryBlockRootContext.expose;

/**
 * Reads listing query details from registered root renders.
 */
export const consumeListingQueryBlockRootContext = listingQueryBlockRootContext.consume;
